import { render, staticRenderFns } from "./ReviewPopup.vue?vue&type=template&id=55fb9ad3&"
import script from "./ReviewPopup.vue?vue&type=script&lang=js&"
export * from "./ReviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports